import React from 'react'
import { SvgIcon } from '@material-ui/core'

const GridViewIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#1C1C1C"
      >
        <g fillRule="evenodd">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z" />
        </g>
      </svg>
    </SvgIcon>
  )
}

export default GridViewIcon
